module.exports = __webpack_public_path__ + "static/media/chicky_circle.a6efd10c.png";